@switch (viewMode()) {
  @case ('list') {
    <!-- List row -->
    <article
      class="flex items-center gap-4 px-4 py-3 rounded-lg border border-border bg-white hover:shadow-sm transition-shadow cursor-pointer"
      (click)="viewDetails.emit(update())"
      (keydown)="($event.key === 'Enter' || $event.key === ' ') && viewDetails.emit(update())"
    >
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2 mb-0.5">
          <app-jurisdiction-flag [jurisdiction]="update().jurisdiction" />
          <span class="text-sm font-medium line-clamp-1">{{ update().title }}</span>
        </div>
        <div class="flex items-center gap-2 flex-wrap">
          <span class="text-xs text-muted">{{ update().jurisdiction }}</span>
          @if (update().categoryName) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border bg-teal-50 text-teal-700 border-teal-200 truncate max-w-[160px]">
              {{ update().categoryName }}
            </span>
          }
        </div>
      </div>
      @if (update().source) {
        <span class="text-xs text-muted whitespace-nowrap hidden sm:block max-w-[160px] truncate">{{ update().source }}</span>
      }
      @if (update().rank) {
        <span class="text-xs text-muted whitespace-nowrap hidden md:block">{{ update().rank }}</span>
      }
      <span class="text-xs text-muted whitespace-nowrap">{{ pubDate() }}</span>
      <span [class]="impactBadgeClass()" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold">
        {{ update().impactLevel }}
      </span>
      <button
        (click)="$event.stopPropagation(); toggleFavourite.emit(update().id)"
        class="p-1.5 rounded hover:bg-gray-100 transition-colors"
        [attr.aria-label]="update().isFavourited ? 'Remove from favourites' : 'Add to favourites'"
      >
        <lucide-angular
          name="star"
          [size]="16"
          [class]="update().isFavourited ? 'text-yellow-500 fill-yellow-500' : 'text-muted'"
        />
      </button>
    </article>
  }
  @default {
    <!-- Grid card -->
    <article
      class="bg-white rounded-lg border border-border shadow-sm flex flex-col h-full hover:shadow-md transition-shadow cursor-pointer"
      (click)="viewDetails.emit(update())"
      (keydown)="($event.key === 'Enter' || $event.key === ' ') && viewDetails.emit(update())"
    >
      <!-- Hero image -->
      @if (cardImage()) {
        <div class="w-full h-40 overflow-hidden rounded-t-lg flex-shrink-0">
          <img
            [src]="cardImage()!"
            alt=""
            loading="lazy"
            class="w-full h-full object-cover"
          />
        </div>
      }

      <div class="p-4 flex-1 flex flex-col">
        <!-- Row 1: impact badge + flag + jurisdiction + star -->
        <div class="flex items-center justify-between gap-2 mb-2">
          <div class="flex items-center gap-1.5 flex-wrap min-w-0">
            <span [class]="impactBadgeClass()" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold capitalize shrink-0">
              {{ update().impactLevel }} Impact
            </span>
            <app-jurisdiction-flag [jurisdiction]="update().jurisdiction" />
            <span class="text-xs font-medium text-gray-700 truncate">{{ update().jurisdiction }}</span>
          </div>
          <button
            (click)="$event.stopPropagation(); toggleFavourite.emit(update().id)"
            class="p-1 rounded hover:bg-gray-100 transition-colors shrink-0"
            [attr.aria-label]="update().isFavourited ? 'Remove from favourites' : 'Add to favourites'"
          >
            <lucide-angular
              name="star"
              [size]="16"
              [class]="update().isFavourited ? 'text-yellow-500 fill-yellow-500' : 'text-muted'"
            />
          </button>
        </div>

        <!-- Title -->
        <h3 class="text-sm font-semibold mb-2 line-clamp-2">{{ update().title }}</h3>

        <!-- Dates -->
        <div class="flex items-center gap-3 text-xs text-muted mb-2 flex-wrap">
          <span class="flex items-center gap-1.5">
            <lucide-angular name="calendar" [size]="11" class="shrink-0" />
            <span>{{ pubDate() }}</span>
          </span>
          @if (updatedDate()) {
            <span class="flex items-center gap-1.5">
              <lucide-angular name="refresh-cw" [size]="11" class="shrink-0" />
              <span>Updated {{ updatedDate() }}</span>
            </span>
          }
        </div>

        <!-- Category chip + source + rank -->
        <div class="flex items-center gap-2 flex-wrap mb-3">
          @if (update().categoryName) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border bg-teal-50 text-teal-700 border-teal-200 truncate max-w-full">
              {{ update().categoryName }}
            </span>
          }
          @if (update().source) {
            <span class="text-xs text-muted truncate">{{ update().source }}</span>
          }
          @if (update().rank) {
            <span class="text-xs text-muted shrink-0">Rank {{ update().rank }}</span>
          }
        </div>

        <!-- Summary -->
        <p class="text-xs text-muted flex-1 line-clamp-3">{{ summary() }}</p>
      </div>

      <div class="px-4 pb-4">
        <button
          appButton
          variant="outline"
          size="sm"
          class="w-full"
          (click)="$event.stopPropagation(); viewDetails.emit(update())"
        >
          Read more
        </button>
      </div>
    </article>
  }
}
